import { useEffect, useState } from 'react';
import { Badge, Skeleton } from 'antd';
import { dataForDayOffTables, dataForDayOffTablesCancel, sortingDate } from 'shared/helpers/utils';
import { RequestsSearch, TColumns } from 'shared/types/types';
import { SortCondition } from 'shared/enums';
import { usePullSort } from 'shared/hooks';
import { useIndicators } from 'features/indicators';
import { ONE_MINUTE } from 'shared/constants';
import { SearchKeysNews } from 'shared/enums/news';
import { TableInProgressDayOff } from 'features/tables/tableInProgressDayOff';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  DayOffsStatusesMap,
  DayOffsStatusTypesMap,
  DayOffTabs,
  TPreparedDayOffPublicated,
} from 'shared/types/dayoff.types';
import { useLazyDayoffsCanceledQuery } from 'app/services/edpApiV1/cancelDayoff';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import style from './index.module.scss';

export const DayOffInProgress = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [dataDayOffs, setDataDayOffs] = useState<TPreparedDayOffPublicated[] | []>([]);
  const [sortInfo, trigger] = usePullSort();
  const dispatch = useAppDispatch();
  const sortOption = sortInfo.value && sortInfo.value === SortCondition.ASCEND ? SortCondition.ASC : SortCondition.DESC;
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const dataSourcecMock = useAppSelector(state => state.entities.dayOff.dayOff);

  // Добавляем пуллинг обновления списка и обновляем индикаторы через хук useIndicators
  const [getDayOffs, { data, isSuccess, isFetching, isLoading }] = useLazyDayoffsCanceledQuery({
    pollingInterval: ONE_MINUTE,
  });

  useEffect(() => {
    getDayOffs({
      type: DayOffTabs.my,
      size: currentSize,
      page: currentPage,
      order: sortInfo.value ? sortOption : undefined,
      allAvailableOrganizations,
      ...search,
    });
  }, [currentPage, currentSize, getDayOffs, search, sortInfo.value, sortOption, allAvailableOrganizations]);

  const onSearch = (data: string, key: SearchKeysNews) => {
    if (key === SearchKeysNews.SEARCH_ID) {
      setSearch({ fio: undefined, byId: data ? data : undefined });
    } else if (key === SearchKeysNews.SEARCH_NAME) {
      setSearch({ byId: undefined, fio: data ? data : undefined });
    } else {
      setSearch({ [key]: data ? data : undefined });
    }
  };

  const columns: TColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: (a, b) => sortingDate(a.created, b.created),
      onHeaderCell: () => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },

    {
      title: 'Дата начала',
      dataIndex: 'dayOffDate',
      key: 'dayOffDate',
    },
    {
      title: 'Дата окончания',
      dataIndex: 'endedAt',
      key: 'endedAt',
    },

    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (status: string, record) => {
        return (
          <>
            <span>
              <Badge className={style.badge} status={DayOffsStatusTypesMap[status]} />
              {DayOffsStatusesMap[status]}
            </span>
            <br />
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (data) {
      const dataTable = dataForDayOffTablesCancel(data?.data || []);
      if (dataTable) {
        setDataDayOffs(dataTable);
      }
    }
  }, [data]);
  // подписываемся на обновление индикаторов, после обновления списка и отключаем пуллинг звпроса индикаторов
  useIndicators(isSuccess, isFetching, false);

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          {dataDayOffs && columns && (
            <TableInProgressDayOff
              dataSource={dataDayOffs}
              columns={columns}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              currentSize={currentSize}
              setCurrentSize={setCurrentSize}
              total={data?.pagination?.total}
              onSearch={onSearch}
              isCancel={true}
            />
          )}
        </>
      )}
    </>
  );
};
